export enum Intensjon {
  Unknown = 0,
  Proposal = 1,
  Plan = 2,
  Order = 3,
  OriginalOrder = 4,
  ReflexOrder = 5,
  FillerOrder = 6,
  InsanceOrder = 7,
  Option = 8,
}
